import React, { useState, useEffect } from "react";
import Loadable from "react-loadable";
import homeCar from "../../Assets/newAsset/lpassets/homeCar.svg";
import logoWhite from "../../Assets/newAsset/lpassets/clearFooter.svg";
import { FiPhone, FiMail, FiSearch } from "react-icons/fi";
import { useParams } from "react-router";
import Loader from "../../components/Loader/Loader";
import Content from "../homePage/Components/Content";
import LpForm from "./Component/LpForm";
import Meta from "../../components/Meta";
import OutsideAlerter from "../../components/CustomHooks/OutSideClick";
import {
  getCall,
  getAllPackageList,
  getCustomerDashboard,
  setCity,
} from "../../Redux/Actions";
import { connect, useDispatch, useSelector } from "react-redux";
import "./Lp.css";
import Actions from "./LpActions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { AiOutlineSearch } from "react-icons/ai";

import FooterLogo from "../../Assets/RedcliffeImagingFooter.png";
import HeaderLogo from "../../Assets/RecliffeImagingHeader.png";
import gambhir from "../../Assets/Gambhi.webp";
// D:\qa_branch\redcliffelabs_frontend_ssr\src\Assets\newAsset\lpassets\Samantha_M.webp
import samantha from "../../Assets/newAsset/lpassets/Samantha_M (1).webp";
import { IoMdCall } from "react-icons/io";

import Searchbar from "../../components/SearchBar/Searchbar";
import { useHistory, NavLink, useLocation } from "react-router-dom";
import { BiTimeFive } from "react-icons/bi";
import { BsArrowUpRight } from "react-icons/bs";
import { AiOutlineRight, AiFillStar } from "react-icons/ai";
import { ImCross } from "react-icons/im";
import { Modal } from "react-responsive-modal";
import Popup from "../../components/PopupNotification/LpPopup";

const scrollTop = () => {
  window.scroll({
    top: 340,
    left: 0,
    behavior: "smooth",
  });
};

const stepsData = [
  {
    id: 1,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/245666fd-7e57-4dae-90bb-a8381ac0da59.webp",
    desc: "Temperature Checks",
  },
  {
    id: 2,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/5aa857e6-ec25-48f9-a86d-7de73342fa20.webp",
    desc: "Secure Packaging",
  },
  {
    id: 3,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac00e3ea-c6c1-4432-8a67-1260075a892f.webp",
    desc: "Stored Safely",
  },
  {
    id: 4,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/84cad4f1-ba4e-40ec-8380-10e1e2223ba8.webp",
    desc: "Regular Sanitization",
  },
  {
    id: 5,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/0b9d508f-c135-4ccb-a61c-d73cd7f25c0a.webp",
    desc: "No Contact Delivery",
  },
];

export const Steps = () => {
  return (
    <div className="safetyDiv">
      <h3>5 Steps to Safety</h3>
      <p>
        <span>10+ Lacs</span> Total orders delivered
      </p>
      <div className="safetySteps">
        {stepsData.map((values, index) => (
          <div className="safety__card" key={values.id}>
            <div className="safety_cardIMG">
              <img width="100%" src={values.img} alt="image"></img>
            </div>
            <div className="steps">
              <span>{values.id}</span>
            </div>
            <div className="safetyStep">
              <span>{values.desc}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
//FAQ's Data//

//why choose us
// export const WhyChooseUs = () => {
//   return (
//     <div className="WhyChooseUs">
//       <div className="whyUscontainer">
//         <h3>Why Choose Us?</h3>
//         <div className="Four_div_box">
//           <div className="For_Image_And_text">
//             <div className="WhyChooseUslogo">
//               <img
//                 src={
//                   "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ae34b20a-80ce-4813-b2e8-e1afb4731f53.webp"
//                 }
//                 alt="Assured Safety"
//               />
//             </div>
//             <p className="whyChooseUspara"> Assured Safety</p>
//           </div>
//           <div className="For_Image_And_text">
//             <div className="WhyChooseUslogo">
//               <img
//                 src={
//                   "https://staticcdn.redcliffelabs.com/media/gallary-images/None/6e9c830a-513d-4477-a405-61abc9e94187.webp"
//                 }
//                 alt="Certified Labs"
//               />
//             </div>
//             <p className="whyChooseUspara"> Certified Labs</p>
//           </div>
//           {packDetail?.org_type !== 'imaging' && <div className="For_Image_And_text">
//             <div className="WhyChooseUslogo">
//               <img
//                 src={
//                   "https://staticcdn.redcliffelabs.com/media/gallary-images/None/d790df8a-dc9c-4355-bd73-4b4d81821382.webp"
//                 }
//                 alt="Free Sample Pick-Up"
//               />
//             </div>
//             <p className="whyChooseUspara">{packDetail.offer_price > 498 ? 'Free' : null} Sample Pick-Up</p>
//           </div>}
//           <div className="For_Image_And_text">
//             <div className="WhyChooseUslogo">
//               <img
//                 src={
//                   "https://staticcdn.redcliffelabs.com/media/gallary-images/None/02f40e8a-d0ff-41de-bdea-4f69968c0ae0.webp"
//                 }
//                 alt="Accurate Reports"
//               />
//             </div>
//             <p className="whyChooseUspara"> Accurate Reports</p>
//           </div>
//         </div>
//         <div className="forBackgroundcolor">{/* Blank */}</div>
//       </div>
//     </div>
//   );
// };

function Lp(props) {
  const dispatch = useDispatch();
  const Featured = Loadable({
    loader: () => import("../homePage/Components/Featured"),
    loading: Loader,
  });

  const Apointment = Loadable({
    loader: () => import("../homePage/Components/Apointment"),
    loading: Loader,
  });

  const ScrolltoTop = Loadable({
    loader: () => import("../../components/Scrolltotop/ScrolltoTop"),
    loading: Loader,
  });

  const FaqAccorComponent = Loadable({
    loader: () => import("../homePage/FaqAccorComponent"),
    loading: Loader,
  });

  const ErrorPage = Loadable({
    loader: () => import("../ErrorPage"),
    loading: Loader,
  });

  const [userName, setUserName] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  const [footerTel, setTelNum] = useState("");
  const [leadSource, setleadSource] = useState("");
  const [lpImage, setlpImage] = useState(false);
  const [disable, setDisable] = useState(true);
  const [tenSecPass, settenSecPass] = useState(false);
  const [showPopUp, setshowPopUp] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const params = useParams();

  const AliasPackArray = [
    "smart-full-body-checkup-with-kidney-function-kft-test",
    "smart-full-body-checkup-with-liver-function-lft-test",
    "smart-full-body-checkup-with-urine-routine-&-microscopy",
    "smart-full-body-checkup-with-thyroid-tests",
    "smart-full-body-checkup-with-lipid-profile-test",
    "smart-full-body-checkup-with-cbc-test",
  ];
  const pacakgeNameFromUrl = params.slug;

  const [displaySearchDiv, setDisplaySearchDiv] = useState(false);
  const [display1, setDisplay1] = useState(false);
  const [searchValue, setSearch] = useState("");
  const [hideRecent, setHideRecent] = useState(false);
  const [open1, setOpen1] = useState(false);
  const onOpenModal1 = () => setOpen1(true);
  const onCloseModal1 = () => setOpen1(false);

  //getting city

  const navCity = useSelector((state) => state.navCityList);
  const { navCities, loading: cityLoading } = navCity;

  const handelCity = (e) => {
    const userProfile = JSON.parse(localStorage.getItem("user"));
    localStorage.setItem("city", e.target.value);
    dispatch(setCity(e.target.value));

    e.target.blur();
    // userProfile && userProfile !== ""
    //   ? dispatch(EmptyCart(userProfile && userProfile.token, successCd))
    //   : null;
  };

  /////////////////////////////////////////////////

  const removeRecent = () => {
    setRecentSearches([]);
    localStorage.setItem("recentSearches", JSON.stringify([]));
  };

  //delete snglr
  const deleteThis = (slug) => {
    const filteredRecent = recentSearches.filter((searches) => {
      return searches.slug !== slug;
    });
    setRecentSearches(filteredRecent);
    localStorage.setItem("recentSearches", JSON.stringify(filteredRecent));
  };

  //Getting Search Value
  const [login, setLogin] = useState(false);
  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (userDetails && userDetails.token) {
      setLogin(true);
      dispatch(getCustomerDashboard(userDetails.token));
    } else {
      setLogin(false);
    }
    const token = userDetails && userDetails.token;

    if (searchValue !== "") {
      searchValue.length > 2
        ? dispatch(getAllPackageList(searchValue !== "" && searchValue, token))
        : null;
    }
  }, [searchValue, login]);

  const customerDetails = useSelector((state) => state.customerDashboard);
  const { packages, loading: cusloading } = customerDetails;
  const allData = packages?.profile;
  /////////////////RECENT SEARCHES///////////////////////////////
  const [recentSearches, setRecentSearches] = useState([]);

  useEffect(() => {
    setRecentSearches(
      localStorage.getItem("recentSearches") &&
        localStorage.getItem("recentSearches") !== ""
        ? JSON.parse(localStorage.getItem("recentSearches"))
        : []
    );

    // const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

    // if (window?.navigator?.userAgentData) {
    //   setIsMobile(window?.navigator?.userAgentData?.mobile)
    // } else if (isSafari) {
    //   setIsMobile(false)
    // } else {
    //   setIsMobile(true)
    // }

    setIsMobile(false);
  }, []);

  const selectingData = useSelector((state) => state.allpackage);
  const { loading, AllpackDetail } = selectingData;

  //////////////////////////HANDEL CLICK ON SEARCH/////////////////
  const [hideListNow, setHideList] = useState(false);
  const handelSearchClick = (data) => {
    setSearch("");

    // const oldrecentSearch =
    //   localStorage.getItem("recentSearches") &&
    //   localStorage.getItem("recentSearches") !== ""
    //     ? JSON.parse(localStorage.getItem("recentSearches"))
    //     : [];

    // if (oldrecentSearch.length > 5) {
    //   oldrecentSearch.pop();
    //   return;
    // }

    // const changedArray = oldrecentSearch.filter((val) => {
    //   return val.slug !== data.slug;
    // });

    // localStorage.setItem(
    //   "recentSearches",
    //   JSON.stringify([{ name: data.name, slug: data.slug }, ...changedArray])
    // );

    window.location.href = process.env.RAZZLE_APP_BASE_URL + (`/${data.slug}`);
  };

  // console.log("???", location);

  useEffect(() => {
    if (AliasPackArray.includes(pacakgeNameFromUrl)) {
      props.getLppackageAliasDetails(pacakgeNameFromUrl);
    } else {
      if (pacakgeNameFromUrl !== "prime-full-body-check-up") {
        props?.getLppackageDetails(pacakgeNameFromUrl);
      }
    }
  }, [pacakgeNameFromUrl]);

  useEffect(() => {
    console.log(pacakgeNameFromUrl, "///");
    if (pacakgeNameFromUrl.match("prime-full-body-check-up")) {
      console.log("contains url ///");
      // window.location.reload()
      window.location.href = process.env.RAZZLE_APP_BASE_URL + (`/lp/${pacakgeNameFromUrl.replace("check-up", "checkup")}`);
    }
  }, []);

  const packDetail = props?.package;
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE

  //validation on submit button
  useEffect(() => {
    if (userName == "" || userNumber == "") {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [userName, userNumber]);

  const location = useLocation();
  console.log(`https://redcliffelabs.com${location.pathname}`, "///");
  var url = `https://redcliffelabs.com${location?.pathname}/bottom${location?.search}`;
  const [successBtn, setSuccessBtn] = useState(false);

  // useEffect(() => {
  //   setTimeout(() => {
  //     settenSecPass(true);
  //     setOpen(true);
  //   }, 10000);
  // }, []);

  useEffect(() => {
    if (packDetail?.org_type == "imaging") {
      setTelNum("898 898 0101");
    } else if (location?.pathname.includes("/lp/fb/")) {
      setTelNum("898 898 9393");
    } else if (location?.pathname.includes("/lp/sms/")) {
      setTelNum("931 126 1990");
    } else if (location?.pathname.includes("/lp/")) {
      setTelNum("898 898 8585");
    } else {
      setTelNum("898 898 8585");
    }
  });

  useEffect(() => {
    if (location?.pathname.includes("lp/antenatal-test")) {
      setlpImage(true);
    } else if (location?.pathname.includes("lp/cancer-screening-female")) {
      setlpImage(true);
    } else if (location?.pathname.includes("lp/women-smart-health-package")) {
      setlpImage(true);
    } else if (packDetail.recommended_gender == "female") {
      setlpImage(true);
    } else {
      setlpImage(false);
    }
  });

  useEffect(() => {
    if (location?.pathname.includes("/lp-taboola/")) {
      setleadSource("lp-taboola");
    } else {
      setleadSource("Ecommerce");
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      onOpenModal1();
    }, 60000);
  }, []);

  const handelUserName = (e) => {
    setUserName(e.target.value);
    setshowPopUp(false);
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 2
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneEror("Enter a valid number*");
      return false;
    } else {
      return true;
    }
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  const handelPhoneChange = (e) => {
    setshowPopUp(false);
    setUserNumber(e.target.value);
    setPhoneEror("");
  };

  if (props?.package && props?.package?.faq) {
    try {
      if (props?.package?.faq) {
        var faqData = JSON.parse(props?.package?.faq.replaceAll("Delhi", ``));
      } else {
        var faqData = [];
      }
    } catch (error) {
      console.log(error, "FAQ ERROR");
    }
  }

  if (packDetail) {
    try {
      if (
        packDetail.package_city_metainfo &&
        packDetail.package_city_metainfo?.og_tag !== ""
      ) {
        var Og = JSON.parse(packDetail.package_city_metainfo.og_tag);
      } else {
        var Og = JSON.parse(packDetail.og_tag);
      }
    } catch (error) { }
  }

  if (packDetail) {
    try {
      if (
        packDetail.package_city_metainfo &&
        packDetail.package_city_metainfo?.twitter_card !== ""
      ) {
        var twCard = JSON.parse(packDetail.package_city_metainfo.twitter_card);
      } else {
        var twCard = JSON.parse(packDetail.twitter_card);
        // console.log(twCard, "package not city type");
      }
    } catch (error) { }
  }

  if (packDetail) {
    try {
      if (packDetail?.package_city_metainfo) {
        var faqData = JSON.parse(packDetail?.package_city_metainfo?.faq);
      } else if (packDetail?.faq) {
        var faqData = JSON.parse(packDetail?.faq.replaceAll("in Delhi", ``));
      } else {
        var faqData = [];
      }
    } catch (error) {
      console.log(error, "FAQ ERROR");
    }
  }

  if (packDetail) {
    try {
      if (
        packDetail.package_city_metainfo &&
        packDetail.package_city_metainfo?.scratch_code !== ""
      ) {
        var scratch_codeData = packDetail.package_city_metainfo.scratch_code;
      } else if (packDetail.scratch_code) {
        var scratch_codeData = packDetail.scratch_code.replaceAll(
          "in Delhi",
          ``
        );
      } else {
        var scratch_codeData = false;
      }
    } catch (error) { }
    var recommndedPackage = packDetail.related_packages;
  }

  {
    /*var faqData = JSON.parse(
    '[{\r\n\t\t"question": "What is included in a liver function test?",\r\n\t\t"answer": "Liver function tests also known as hepatic panels are the blood tests group that delivers information about the patient’s liver condition. The liver function tests involve albumin, bilirubin, prothrombin time, and activated Partial Thromboplastin (aPTT)."\r\n\t},\r\n\r\n\r\n\t{\r\n\t\t"question": "What are the symptoms of poor liver function?",\r\n\t\t"answer": {\r\n\t\t\t"faq": "The symptoms of poor liver function are:",\r\n\r\n\t\t\t"list": ["Itchy and dry skin. ",\r\n\t\t\t\t" Ankles and legs swelling. ",\r\n\t\t\t\t" Dark urine color. ",\r\n\t\t\t\t" Nausea or vomiting. ",\r\n\t\t\t\t" Yellow eyes and skin.  ",\r\n\t\t\t\t" Abdominal pain and swelling. ",\r\n\t\t\t\t" Severe fatigue."\r\n\t\t\t]\r\n\t\t}\r\n\t},\r\n\r\n\t{\r\n\t\t"question": "What is the best test for liver function?",\r\n\t\t"answer": "The albumin test is identified as the best test for liver function test as it has the efficiency of identifying whether the liver is producing albumin or not. Secondly, bilirubin is also useful it helps in measuring the efficiency of bilirubin disposal.  "\r\n\t},\r\n\r\n\t{\r\n\t\t"question": "What is a normal liver function blood test result? ",\r\n\t\t"answer": "The normal blood function tests involve ALT 7-55 units per litre and AST 8-48 units per litre."\r\n\t},\r\n\r\n\t{\r\n\t\t"question": "Do I need to do anything special to prepare for the LFT test? ",\r\n\t\t"answer": "Yes, your doctor may ask you to stop eating and drinking for around eight to twelve hours before the test. You also need to convey if you are already on some medications as it can lead to affecting the test results. "\r\n\t}\r\n]'
  ); */
  }

  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();

    if (checkVal) {
      const body = {
        name: userName,
        phone_no: userNumber,
        source: leadSource,
        city: "",
        url,
      };

      setUserNumber("");
      setUserName("");
      setSuccessBtn(true);
      setTimeout(() => {
        setSuccessBtn(false);
      }, 2000);
      setPhoneEror("");

      dispatch(getCall(body));
    }
  };
  // console.log(org_type !== 'imaging', "type")

  //getting city selected
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;

  const history = useHistory();

  const toHealthPackages = () => {
    console.log("works");
    window.location.href = (process.env.RAZZLE_APP_BASE_URL +
      `/health-checkup-packages${citySelect ? `/${citySelect.toLowerCase().replace(" ", "-")}` : ""
      }`
    );
  };
  const toImagingHealthPackages = () => {
    console.log("works");
    history.push(
      `/imaging/health-checkup-packages${citySelect ? `-${citySelect.toLowerCase().replace(" ", "-")}` : ""
      }`
    );
  };
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const [modalUserName, setModalUserName] = useState("");
  const [modalUserNumber, setModalUserNumber] = useState("");
  const [modalNameError, setModalNameError] = useState("");
  const [modalNumberError, setModalNumberError] = useState("");
  const [modalBtnDisable, setModalBtnDisable] = useState(true);
  const [openSuccModel, setSucc] = useState(false);
  const openSucess = () => setSucc(true);
  const closeSuccess = () => setSucc(false);

  const handelModalUserName = (e) => {
    setModalUserName(e.target.value);
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setModalNameError("");
    if (!e.target.value.match(characterRegex)) {
      setModalNameError("invalid user name");
    }
    if (e.target.value == "") {
      setModalNameError("");
    }
  };
  const handelModalPhoneChange = (e) => {
    setModalUserNumber(e.target.value);
    setModalNumberError("");
  };

  const validateModalPhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!modalUserNumber.match(phoneno) || parseInt(modalUserNumber[0]) < 6) {
      setModalNumberError("Enter a valid number");
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (modalUserName == "" || modalUserNumber.length != 10) {
      setModalBtnDisable(true);
    } else {
      setModalBtnDisable(false);
    }
  }, [modalUserName, modalUserNumber]);

  const handleModalFormSubmit = (e) => {
    const checkVal = validateModalPhoneNumber();
    if (checkVal) {
      const body = {
        name: modalUserName,
        phone_no: modalUserNumber,
        source: "Ecommerce",
        url: `https://redcliffelabs.com${location?.pathname}/model`,
        city: "",
      };
      setModalUserNumber("");
      setModalUserName("");
      setModalNumberError("");
      dispatch(getCall(body));
      setSucc(true);
      openSucess(true);
      setTimeout(() => {
        setSucc(false);
      }, 2000);
    }
  };
  const handelSearch = (e) => {
    setDisplay1(true);
    setSearch(e.target.value);
  };
  const SuccessModel = ({ number }) => {
    return (
      <div className="SuccessMsg_upload">
        <h2>
          We have received your information. We shall call you in few minutes to
          confirm the details. For any queries please call us at &nbsp;
          <a href={`tel:+91-${number}`} style={{ color: "blue" }}>
            {number}
          </a>{" "}
          - Team Redcliffe Labs
        </h2>
      </div>
    );
  };
  return props?.loading ? (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Loader />
    </div>
  ) : props?.package?.length == 0 ? (
    <div className="errorDIVNo">
      <ErrorPage />
      <div className="footerLp">
        <div className="footerContainer">
          <div className="footerFirstRow">
            <div className="logoIMg">
              <img
                className="lpimg"
                width="100%"
                src={
                  packDetail?.org_type !== "imaging"
                    ? "https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                    : "https://staticcdn.redcliffelabs.com/media/gallary-file/None/39350684-4581-4a0d-b297-52fb3452aa93.webp"
                }
                alt={logoWhite}
              ></img>
            </div>
            <div className="footerDesc">
              <p>
                Redcliffe Labs is an accredited advanced diagnostic laboratory
                that aims at providing top-notch consistent and accurate
                laboratory services with modern technology and equipment all
                inclusive of logistics management.
              </p>
            </div>
          </div>
          <div className="footerSecondRow">
            <div className="footerLogo">
              <span>Contact Us</span>
              <div className="emailLogo">
                <span>
                  <FiMail />
                </span>
                care@redcliffelabs.com
              </div>
              <a href={`tel:+91${footerTel}`}>
                <div className="phoneLogo">
                  <span>
                    <FiPhone />
                  </span>
                  {footerTel}
                </div>
              </a>
            </div>
          </div>
          <div className="borderDiv"></div>
          <div className="footerThirdRow">
            <div className="footerMsg">
              <p>
                Disclaimer: As per "Pre-Natal Diagnostic Techniques (Regulation
                and prevention of Misuse) Act, 1994", our labs strictly does not
                determine the sex of the fetus.
              </p>
              <p>
                Redcliffe Labs <br /> © 2022. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="SuperClassNormalLp ">
      {packDetail?.meta_title && packDetail?.og_tag && Og && twCard && (
        <Meta
          title={
            packDetail.package_city_metainfo
              ? packDetail.package_city_metainfo.meta_title
              : packDetail.meta_title?.replace("in Delhi", ``)
          }
          description={
            packDetail.package_city_metainfo
              ? packDetail.package_city_metainfo.meta_description
              : packDetail.meta_description?.replace("in Delhi", ``)
          }
          keywords={
            packDetail.package_city_metainfo
              ? packDetail.package_city_metainfo.meta_keyword
              : packDetail.meta_keyword
          }
          canonicalUrl={`https://redcliffelabs.com${location.pathname}`}
        >
          <meta property="robots" content={Og.robots ? Og.robots : ""} />
          <meta
            property="og:title"
            content={Og?.title?.replace("in Delhi", ``)}
          />
          <meta property="og:site_name" content={Og.site} />
          <meta property="og:url" content={Og?.url?.replace("delhi", ``)} />
          <meta property="og:description" content={Og?.description} />
          <meta property="og:type" content={Og?.type} />
          <meta property="og:image" content={Og?.image} />
          {scratch_codeData ? (
            <script type="application/ld+json">{scratch_codeData}</script>
          ) : null}
          <script type="application/ld+json">{JSON.stringify(faqData)}</script>
          <meta name="twitter:card" content={twCard ? twCard.card : ""} />
          <meta name="twitter:site" content={twCard ? twCard.site : ""} />
          <meta
            name="twitter:title"
            content={twCard ? twCard.title?.replace("in Delhi", ``) : ""}
          />
          <meta
            name="twitter:description"
            content={twCard ? twCard.description?.replace("in Delhi", ``) : ""}
          />
          <meta name="twitter:image" content={twCard ? twCard.image : ""} />
        </Meta>
      )}
      <div
        className={
          lpImage ? "lpimages NewlpBackground " : "defaultImg NewlpBackground "
        }
      >
        <div className="newMobileBackground">
          <div className="redLogos_milinTest">
            <div
              className={
                displaySearchDiv
                  ? "leftSide_lp leftSide_lpWSeach"
                  : "leftSide_lp"
              }
            >
              {packDetail?.org_type !== "imaging" ? (
                <img
                  className="cursorPointer"
                  width="100%"
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/69780ca3-4abe-4f88-a130-7a1f182ec0bd.webp"
                  alt="transparentLOGO"
                  onClick={toHealthPackages}
                />
              ) : (
                <img
                  className="cursorPointer"
                  width="100%"
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/1260204a-0e52-4235-82a0-e3c9fe214c15.webp"
                  alt="transparentLOGO"
                  onClick={toImagingHealthPackages}
                />
              )}
            </div>
            {displaySearchDiv ? (
              <>
                <div className="inputbAR inputbARLp">
                  <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/d1ec7938-f1cf-4a07-885f-9550c249a777.svg" />
                  <input
                    placeholder="Search Tests, Package, Body Areas.."
                    onChange={(e) => setSearch(e.target.value)}
                    onClick={() => setHideRecent(false)}
                    value={searchValue}
                  />
                  {hideListNow ? null : (
                    <div
                      className={hideRecent ? "recentSearch" : "recentSearches"}
                    >
                      <h4 style={{ fontWeight: "500", margin: "1rem" }}>
                        {searchValue == "" || searchValue.length < 4 ? (
                          recentSearches.length > 0 ? (
                            <div className="recentDiv">
                              <span className="noPointer">
                                {" "}
                                <BiTimeFive
                                  style={{
                                    marginRight: "1rem",
                                    fontSize: "2rem",
                                  }}
                                />{" "}
                                Recent searches{" "}
                              </span>
                              <span className="danger" onClick={removeRecent}>
                                Clear History
                              </span>
                            </div>
                          ) : null
                        ) : searchValue.length > 2 &&
                          AllpackDetail &&
                          AllpackDetail.count > 0 ? (
                          `Found ${AllpackDetail.count} results `
                        ) : recentSearches.length > 0 ? (
                          <div className="recentDiv">
                            {/* <span className="noPointer"> Recent searches </span>
                           <span onClick={removeRecent} className="danger">
                             Clear History
                           </span> */}
                          </div>
                        ) : null}
                      </h4>

                      <ul className="recentList">
                        {loading ? (
                          <Loader />
                        ) : searchValue !== "" &&
                          searchValue.length > 2 &&
                          AllpackDetail &&
                          AllpackDetail.results &&
                          AllpackDetail.results.length > 0 ? (
                          AllpackDetail.results.map((values) => {
                            return (
                              <li
                                className="deadState"
                                key={values.id}
                                onClick={() => {
                                  handelSearchClick(values);
                                }}
                              >
                                {/* <BiTimeFive />{" "} */}
                                <span>{values.name}</span>
                                <BsArrowUpRight />
                              </li>
                            );
                          })
                        ) : searchValue !== "" && searchValue.length > 2 ? (
                          <p style={{ margin: "1.2rem" }}>No Packages Found</p>
                        ) : recentSearches && recentSearches.length > 0 ? (
                          recentSearches.map((values, index) => (
                            <li className="deadState" key={index}>
                              <div
                                className="danger cross"
                                onClick={() => deleteThis(values.slug)}
                              >
                                <ImCross />
                              </div>
                              <a
                                href={process.env.RAZZLE_APP_BASE_URL + `/${values.slug}${citySelect
                                  ? `-${citySelect
                                    .toLowerCase()
                                    .replace(" ", "-")}`
                                  : ""
                                  }`}
                              >
                                <span>{values.name}</span>
                                <BsArrowUpRight />
                              </a>
                            </li>
                          ))
                        ) : null}
                      </ul>
                      <h4 style={{ fontWeight: "500", margin: "1rem " }}>
                        Popular Searches
                      </h4>
                      <ul className="recentList">
                        <li className="deadState ">
                          <a
                            href={process.env.RAZZLE_APP_BASE_URL + `/advance-full-body-checkup${citySelect
                              ? `-${citySelect
                                .toLowerCase()
                                .replace(" ", "-")}`
                              : ""
                              }`}
                          >
                            <div className="start">
                              <AiFillStar />
                            </div>
                            <span>Advance Full Body Checkup</span>{" "}
                            <BsArrowUpRight />{" "}
                          </a>
                        </li>

                        <li className="deadState ">
                          <a
                            href={process.env.RAZZLE_APP_BASE_URL + `/smart-full-body-checkup${citySelect
                              ? `-${citySelect
                                .toLowerCase()
                                .replace(" ", "-")}`
                              : ""
                              }`}
                          >
                            <div className="start">
                              <AiFillStar />
                            </div>
                            <span>Smart Full Body Checkup</span>{" "}
                            <BsArrowUpRight />{" "}
                          </a>
                        </li>

                        <li className="deadState ">
                          <a
                            href={process.env.RAZZLE_APP_BASE_URL + `/uric-acid-test${citySelect
                              ? `-${citySelect
                                .toLowerCase()
                                .replace(" ", "-")}`
                              : ""
                              }`}
                          >
                            <div className="start">
                              <AiFillStar />
                            </div>
                            <span>Uric Acid Test </span> <BsArrowUpRight />
                          </a>
                        </li>

                        <li className="deadState ">
                          <a
                            href={process.env.RAZZLE_APP_BASE_URL + `/vitamin-profile-test${citySelect
                              ? `-${citySelect
                                .toLowerCase()
                                .replace(" ", "-")}`
                              : ""
                              }`}
                          >
                            <div className="start">
                              <AiFillStar />
                            </div>
                            <span>Vitamin Profile test </span>{" "}
                            <BsArrowUpRight />{" "}
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>

                {/* <div className="cityDrop">
                  Location :
                  <div className="locationDrop">
                    <select onChange={handelCity} className="SelectDrop">
                      <option value="">Select City</option>
                      {navCity &&
                      navCity.navCities &&
                      navCity.navCities.cities ? (
                        navCities.cities.map((ele, index) => {
                          return (
                            <option
                              className="option"
                              key={index}
                              selected={ele == citySelected.citySelect}
                              value={ele}
                            >
                              {ele.replace("_", " ")}
                            </option>
                          );
                        })
                      ) : (
                        <Loader />
                      )}
                    </select>
                  </div>
                </div> */}
              </>
            ) : null}
            <div className="rightSide_lp lpSearchAndNumber">
              <div
                className="searchIconMob searchIconMobLp"
                onClick={() => setDisplaySearchDiv(!displaySearchDiv)}
              >
                <FiSearch />
              </div>

              {/* <div className="top__bar">
              <p>No.1 Diagnostics Lab for me & my family!</p>
             </div> */}
              {/* <div className="bottom__bar">
                <span>~Milind Soman</span>
              </div> */}
            </div>
          </div>
          <div className="lpHeaderCall">
            <button>
              {" "}
              <a href={`tel:+91${footerTel}`}>
                <IoMdCall /> {footerTel}{" "}
              </a>
            </button>
          </div>

          {/* //////////////////////////////////// */}

          {/* //////////////////////////////////// */}

          <div className="milindImages_new">
            {/* <img
            width="100%"
            src="https://staticcdn.redcliffelabs.com/media/gallary-images/None/58e6f495-3471-47a5-bcfd-2ff6aa0d3094.png"
            alt="profile-img"
            className="bannerImg_newLP"
          />
          <img
            width="100%"
            src="https://staticcdn.redcliffelabs.com/media/gallary-images/None/1e7366d6-2d04-409e-bd59-3c785f0595ab.png"
            alt="eclipse"
            className="eclipse"
          /> */}
            {/* {packDetail && packDetail.name ? (
              <p className="mainTagHeadingMobile">{packDetail?.name}</p>
            ) : null} */}

            {packDetail && packDetail.name ? (
              <p className="mainTagHeadingMobile">
                {" "}
                {packDetail?.name.includes("Checkup") ? (
                  <p style={{ color: "#e5184e" }}>
                    {packDetail?.name.replace("Checkup", " ")}{" "}
                    <span style={{ fontWeight: "700", color: "#0e416b" }}>
                      Checkup
                    </span>
                  </p>
                ) : (
                  packDetail?.name
                )}
              </p>
            ) : null}

            <div className="MobileParameters">
              <p className="parameterFont">
                Test Parameters{" "}
                {packDetail && packDetail?.parameter
                  ? packDetail.parameter
                  : null}{" "}
                {packDetail?.parameter == 1
                  ? " test only"
                  : " tests which includes "}
              </p>

              {/**description */}

              <p className="paraDesc">
                {packDetail && packDetail.description
                  ? packDetail.description
                  : null}
              </p>
              <div className="newCardslp">
                <div className="NewlpDivRow taboolaCards">
                  {packDetail?.org_type !== "imaging" &&
                    packDetail?.tat_time ? (
                    <div className="lpcards">
                      <div className="card__imglp">
                        <LazyLoadImage
                          src={
                            "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                          }
                          alt={
                            "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                          }
                          delayTime="100"
                          width="100%"
                        />
                      </div>
                      <div className="card__contentlp">
                        <span className="mainHeading">Get Reports in</span>
                        <span className="redHeading">
                          {packDetail?.tat_time}
                        </span>
                      </div>
                    </div>
                  ) : null}
                  {packDetail?.org_type !== "imaging" &&
                    packDetail &&
                    packDetail.fasting_time ? (
                    <div className="lpcards ">
                      <div className="card__imglp">
                        <LazyLoadImage
                          src={
                            "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                          }
                          alt={
                            "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                          }
                          delayTime="100"
                          width="100%"
                        />
                      </div>
                      <div className="card__contentlp">
                        <span className="mainHeading">
                          {" "}
                          Patient Instruction
                        </span>
                        <span className="redHeading">
                          {packDetail.fasting_time}
                        </span>
                      </div>
                    </div>
                  ) : null}
                  {/**sample information */}
                  {packDetail?.org_type !== "imaging" &&
                    packDetail &&
                    packDetail.sample ? (
                    <div className="lpcards">
                      <div className="card__imglp">
                        <LazyLoadImage
                          src={
                            "https://staticcdn.redcliffelabs.com/media/gallary-images/None/3f2cc36c-46ba-4f3b-a0be-9e2a4691f317.webp"
                          }
                          alt={
                            "https://staticcdn.redcliffelabs.com/media/gallary-images/None/3f2cc36c-46ba-4f3b-a0be-9e2a4691f317.webp"
                          }
                          delayTime="100"
                          width="100%"
                        />
                      </div>
                      <div className="card__contentlp">
                        <span className="mainHeading">Sample Collection</span>
                        <span className="redHeading">{packDetail.sample}</span>
                      </div>
                    </div>
                  ) : null}

                  {/**Home collection packDetail.home_collection */}
                  {packDetail?.org_type !== "imaging" &&
                    packDetail &&
                    packDetail.home_collection ? (
                    <div className="lpcards">
                      <div className="card__imglp">
                        <LazyLoadImage
                          src={homeCar}
                          alt={homeCar}
                          delayTime="100"
                          width="100%"
                        />
                      </div>
                      <div className="card__contentlp">
                        <span className="mainHeading">Home Collection</span>
                        <span className="redHeading">Available</span>
                      </div>
                    </div>
                  ) : null}

                  {packDetail?.org_type !== "imaging" &&
                    packDetail &&
                    packDetail.recommended_age ? (
                    <div className="lpcards">
                      <div className="card__imglp">
                        <LazyLoadImage
                          src={
                            "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                          }
                          alt={
                            "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                          }
                          delayTime="100"
                          width="100%"
                        />
                      </div>
                      <div className="card__contentlp">
                        <span className="mainHeading">Age Group</span>
                        <span className="redHeading">
                          {packDetail.recommended_age} years
                        </span>
                      </div>
                    </div>
                  ) : null}
                  {packDetail?.org_type == "imaging" ? (
                    <div className="lpcards">
                      <div className="card__imglp">
                        <img
                          src={
                            "https://staticcdn.redcliffelabs.com/media/gallary-file/None/d4af6e2d-7e56-49ef-8b30-3dca6bfc175c.svg"
                          }
                          width="100%"
                          alt={
                            "https://staticcdn.redcliffelabs.com/media/gallary-file/None/d4af6e2d-7e56-49ef-8b30-3dca6bfc175c.svg"
                          }
                        />
                      </div>
                      <div className="card__contentlp">
                        <span className="mainHeading"> Lady technician</span>
                        <span className="redHeading">Available</span>
                      </div>
                    </div>
                  ) : null}
                  {packDetail?.org_type == "imaging" ? (
                    <div className="lpcards">
                      <div className="card__imglp">
                        <img
                          src={
                            "https://staticcdn.redcliffelabs.com/media/gallary-file/None/7bfe3e30-2046-440b-bf04-e17f0aa3c87e.svg"
                          }
                          width="100%"
                          alt={
                            "https://staticcdn.redcliffelabs.com/media/gallary-file/None/7bfe3e30-2046-440b-bf04-e17f0aa3c87e.svg"
                          }
                        />
                      </div>
                      <div className="card__contentlp">
                        <span className="mainHeading"> Parking facility</span>
                        <span className="redHeading">Available</span>
                      </div>
                    </div>
                  ) : null}
                  {packDetail?.org_type == "imaging" ? (
                    <div className="lpcards">
                      <div className="card__imglp">
                        <img
                          src={
                            "https://staticcdn.redcliffelabs.com/media/gallary-file/None/afa165a6-47e5-424b-97ac-7cf9359b3b87.svg"
                          }
                          width="100%"
                          alt={
                            "https://staticcdn.redcliffelabs.com/media/gallary-file/None/afa165a6-47e5-424b-97ac-7cf9359b3b87.svg"
                          }
                        />
                      </div>
                      <div className="card__contentlp">
                        <span className="mainHeading"> 100 %</span>
                        <span className="redHeading">Covid Safe</span>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="lpContainerNew">
          <div className="brandLogoTop">
            {packDetail?.org_type !== "imaging" ? (
              <img
                className="cursorPointer"
                width="100%"
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/69780ca3-4abe-4f88-a130-7a1f182ec0bd.webp"
                onClick={toHealthPackages}
              ></img>
            ) : (
              <img
                className="cursorPointer"
                width="100%"
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/1260204a-0e52-4235-82a0-e3c9fe214c15.webp"
                onClick={toImagingHealthPackages}
              ></img>
            )}

            <div className="header_searchBar lpHeader_searchBar dis_flex">
              {/* <span style={{ color: "gray" }}> City</span>
                  <div className="verticalLine" />
                  <div className="selectAreaPincode">
                    <select onChange={handelCity} defaultValue="Noida">
                      <option value="">Select City</option>
                      {navCity &&
                      navCity.navCities &&
                      navCity.navCities.cities ? (
                        navCities.cities.map((ele, index) => {
                          return (
                            <option
                              key={index}
                              selected={ele == citySelected.citySelect}
                              value={ele}
                            >
                              {ele.replace("_", " ")}
                            </option>
                          );
                        })
                      ) : (
                        <Loader />
                      )}
                    </select>
                    {/* <div className="selectPincode">
                    <div className="disFlex_column flex-justify">
                      <span className="selectAddress addressFontBold ">
                        Select Address
                      </span>
                      <span>You can add from your addresses</span>
                    </div>
                    <div className="userAddress">
                      <div className="dis_flex flex-justify">
                        <label className="addressFontBold">Lokesh</label>
                        <input
                          value=""
                          type="radio"
                          style={{ width: "auto" }}
                        />
                      </div>
                      <div style={{ marginTop: "1rem" }}>
                        <p className="addrespara">
                          007, Venice Beach, Omaha Estate, 42142
                        </p>
                      </div>
                    </div>
                    <div className="border_horizontal" />
                    <div className="disFlex_column flex-justify">
                      <span className="selectAddress addressFontBold ">
                        Or Enter Pincode
                      </span>
                      <span>Select Pincode to see checkup availability</span>
                      <div className="pincodeInput ">
                        <MdLocationPin />
                        <input placeholder="Enter Pincode" type="text" />
                      </div>
                    </div>
                    
                  </div> 
                  </div> */}
              <OutsideAlerter
                onClickOut={() => {
                  setDisplay1(false);
                }}
              >
                <div className="searchInput LpSearchInput LpSearchInput2">
                  <input
                    type="text"
                    value={searchValue}
                    placeholder="Search for health package or tests"
                    onFocus={(e) => {
                      e.target.select(), setDisplay1(true);
                    }}
                    onChange={handelSearch}
                  />
                  <AiOutlineSearch style={{ fontSize: "2.5rem" }} />
                  {display1 ? (
                    <div className="recentSearches recentSearchesLp">
                      <h4 style={{ fontWeight: "500", margin: "1rem" }}>
                        {searchValue == "" || searchValue.length < 4 ? (
                          recentSearches.length > 0 ? (
                            <div className="recentDiv">
                              <span className="noPointer">
                                {" "}
                                <BiTimeFive
                                  style={{
                                    marginRight: "1rem",
                                    fontSize: "2rem",
                                  }}
                                />{" "}
                                Recent searches{" "}
                              </span>
                              <span className="danger" onClick={removeRecent}>
                                Clear History
                              </span>
                            </div>
                          ) : null
                        ) : searchValue.length > 2 &&
                          AllpackDetail &&
                          AllpackDetail.count > 0 ? (
                          `Found ${AllpackDetail.count} results `
                        ) : recentSearches.length > 0 ? (
                          <div className="recentDiv">
                            {/* <span className="noPointer"> Recent searches </span>
                          <span onClick={removeRecent} className="danger">
                            Clear History
                          </span> */}
                          </div>
                        ) : null}
                      </h4>

                      <ul className="recentList">
                        {loading ? (
                          <Loader />
                        ) : searchValue !== "" &&
                          searchValue.length > 2 &&
                          AllpackDetail &&
                          AllpackDetail.results &&
                          AllpackDetail.results.length > 0 ? (
                          AllpackDetail.results.map((values) => {
                            return (
                              <li
                                className="deadState"
                                key={values.id}
                                onClick={() => handelSearchClick(values)}
                              >
                                {/* <BiTimeFive />{" "} */}
                                <span>{values.name}</span>
                                <BsArrowUpRight />
                              </li>
                            );
                          })
                        ) : searchValue !== "" && searchValue.length > 2 ? (
                          <p style={{ margin: "1.2rem" }}>No Packages Found</p>
                        ) : recentSearches && recentSearches.length > 0 ? (
                          recentSearches.map((values, index) => (
                            <li className="deadState" key={index}>
                              <div
                                className="danger cross"
                                onClick={() => deleteThis(values.slug)}
                              >
                                <ImCross />
                              </div>
                              <a
                                href={process.env.RAZZLE_APP_BASE_URL + `/${values.slug}${citySelect
                                  ? `-${citySelect
                                    .toLowerCase()
                                    .replace(" ", "-")}`
                                  : ""
                                  }`}
                              >
                                <span>{values.name}</span>
                                <BsArrowUpRight />
                              </a>
                            </li>
                          ))
                        ) : null}
                      </ul>
                      <h4
                        style={{ fontWeight: "500", margin: "1rem " }}
                        className="noPointer"
                      >
                        Popular Searches
                      </h4>
                      <ul className="recentList">
                        <li className="deadState ">
                          <a
                            href={process.env.RAZZLE_APP_BASE_URL + `/advance-full-body-checkup${citySelect
                              ? `-${citySelect
                                .toLowerCase()
                                .replace(" ", "-")}`
                              : ""
                              }`}
                          >
                            <div className="start">
                              <AiFillStar />
                            </div>
                            <span>Advance Full Body Checkup</span>{" "}
                            <BsArrowUpRight />{" "}
                          </a>
                        </li>

                        <li className="deadState ">
                          <a
                            href={process.env.RAZZLE_APP_BASE_URL + `/smart-full-body-checkup${citySelect
                              ? `-${citySelect
                                .toLowerCase()
                                .replace(" ", "-")}`
                              : ""
                              }`}
                          >
                            <div className="start">
                              <AiFillStar />
                            </div>
                            <span>Smart Full Body Checkup</span>{" "}
                            <BsArrowUpRight />{" "}
                          </a>
                        </li>

                        <li className="deadState ">
                          <a
                            href={process.env.RAZZLE_APP_BASE_URL + `/uric-acid-test${citySelect
                              ? `-${citySelect
                                .toLowerCase()
                                .replace(" ", "-")}`
                              : ""
                              }`}
                          >
                            <div className="start">
                              <AiFillStar />
                            </div>
                            <span>Uric Acid Test </span> <BsArrowUpRight />
                          </a>
                        </li>

                        <li className="deadState ">
                          <a
                            href={process.env.RAZZLE_APP_BASE_URL + `/vitamin-profile-test${citySelect
                              ? `-${citySelect
                                .toLowerCase()
                                .replace(" ", "-")}`
                              : ""
                              }`}
                          >
                            <div className="start">
                              <AiFillStar />
                            </div>
                            <span>Vitamin Profile test </span>{" "}
                            <BsArrowUpRight />{" "}
                          </a>
                        </li>
                      </ul>
                    </div>
                  ) : null}
                </div>
              </OutsideAlerter>
            </div>

            <button>
              {" "}
              <a href={`tel:+91${footerTel}`}>
                {" "}
                <IoMdCall /> {footerTel}{" "}
              </a>
            </button>
          </div>
          {packDetail && packDetail.name ? (
            <p className="lpmainTagHeadingNoAdlp">
              {" "}
              {packDetail?.name.includes("Checkup") ? (
                <p className="lpmainTagHeadingNoAdlp">
                  {packDetail?.name.replace("Checkup", " ")}{" "}
                  <span style={{ fontWeight: "700", color: "#0e416b" }}>
                    Checkup
                  </span>
                </p>
              ) : (
                packDetail?.name
              )}
            </p>
          ) : null}

          <div className="lpformDivchildren lpTaboolaForm">
            <div className="lpForm">
              <div className="Report__Params">
                <div className="Report__Test bg__blue">
                  <span>
                    {packDetail && packDetail.parameter
                      ? packDetail.parameter
                      : 1}
                  </span>
                  {packDetail && packDetail.parameter > 1 ? "Tests" : "Test"}
                </div>
                <div className="Report__rightSide">
                  <div className="Report__Mrp oldPrice">
                    <span>MRP</span>
                    <span style={{ textDecoration: "line-through" }}>
                      {" "}
                      &#8377;{" "}
                      {packDetail && packDetail.package_price
                        ? packDetail.package_price
                        : null}
                    </span>
                  </div>

                  <div className="Report__offerPrice">
                    <span>Offer Price</span>
                    &#8377;{" "}
                    {packDetail && packDetail.offer_price
                      ? packDetail.offer_price
                      : null}
                  </div>
                </div>
              </div>
              <Modal
                open={tenSecPass && showPopUp && open}
                onClose={onCloseModal}
                center
                classNames={{
                  overlay: "lpFormModalOverlay",
                  modal: "lpFormModal",
                }}
              >
                <div className="canWeHelp">Can We Help ?</div>
                <hr />
                <div className="needHelp">
                  <div className="needHelpHead">
                    Need Help in booking a lab test?
                  </div>
                  <div className="shareDetailsTxt">
                    Share Your details, we will call you!
                  </div>
                  <div className="newLpFormInput">
                    <input
                      onChange={handelModalUserName}
                      value={modalUserName}
                      className="newLpFormInputInput"
                      type="text"
                      placeholder="Name"
                    />
                  </div>
                  <span className="FormError">{modalNameError}</span>
                  <div className="newLpFormPhone">
                    <div className="ind91">IND +91</div>
                    <input
                      onChange={handelModalPhoneChange}
                      value={modalUserNumber}
                      onBlur={() => {
                        validateModalPhoneNumber();
                      }}
                      className="newLpFormInputInput newLpFormInputInputPhone"
                      type="text"
                      placeholder="Phone*"
                    />
                  </div>
                  <span className="FormError">{modalNumberError}</span>
                  <button
                    onClick={handleModalFormSubmit}
                    id="lpPopup"
                    className={
                      modalBtnDisable
                        ? "lpFormModalSubmitBtn  lpFormModalSubmitBtnDis"
                        : "lpFormModalSubmitBtn"
                    }
                  >
                    SUMBIT
                  </button>
                </div>
              </Modal>
              <Modal open={openSuccModel} onClose={closeSuccess} center>
                <SuccessModel number={footerTel} />
              </Modal>
              <LpForm
                isLp={true}
                butname={"SUBMIT"}
                buttonId={"LpTop"}
                formId={"LpForm"}
                lpNumber={footerTel}
                position={"Top"}
                setshowPopUp={() => setshowPopUp(false)}
                offerPrice={packDetail?.offer_price}
                minPhleboCharge={packDetail?.min_booking_amount_for_phlebo}
                push={true}
                isMobile={isMobile}
              />
            </div>
            {/* <div className="startDiv">
            <div className="top__bar">
              <p>No.1 Diagnostics Lab for me & my family!</p>
            </div>
            <div className="bottom__bar">
              <p>Supermodel & Fitness Guru</p>
              <span>~Milind Soman</span>
            </div>
          </div> */}
          </div>
          <div className="desktopDetails">
            <div className="lpFormDiv">
              <div className="NewlpParameters">
                <h5>Test Parameters</h5>

                <p className="parameterFont">
                  Now with{" "}
                  {packDetail && packDetail.parameter
                    ? packDetail.parameter
                    : null}{" "}
                  {packDetail?.parameter == 1
                    ? "test only"
                    : "tests which includes "}
                </p>

                {/**description */}

                <p className="paraDesc">
                  {packDetail && packDetail.description
                    ? packDetail.description
                    : null}
                </p>
              </div>
            </div>
            {faqData?.length > 0 && (
              <div className="lpTestDesc">{faqData[0].answer}</div>
            )}
            <div className="newCardslp lpCard1024">
              <div className="NewlpDivRow ">
                {packDetail?.org_type !== "imaging" && packDetail?.tat_time ? (
                  <div className="lpcards">
                    <div className="card__imglp">
                      <LazyLoadImage
                        src={
                          "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                        }
                        alt={
                          "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                        }
                        delayTime="100"
                        width="100%"
                      />
                    </div>
                    <div className="card__contentlp">
                      <span className="mainHeading">Get Reports in</span>
                      <span className="redHeading">{packDetail.tat_time}</span>
                    </div>
                  </div>
                ) : null}
                {packDetail?.org_type !== "imaging" &&
                  packDetail &&
                  packDetail.fasting_time ? (
                  <div className="lpcards">
                    <div className="card__imglp">
                      <LazyLoadImage
                        src={
                          "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                        }
                        alt={
                          "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                        }
                        delayTime="100"
                        width="100%"
                      />
                    </div>
                    <div className="card__contentlp">
                      <span className="mainHeading"> Patient Instruction</span>
                      <span className="redHeading">
                        {packDetail.fasting_time}
                      </span>
                    </div>
                  </div>
                ) : null}
                {/**sample information */}
                {packDetail?.org_type !== "imaging" &&
                  packDetail &&
                  packDetail.sample ? (
                  <div className="lpcards">
                    <div className="card__imglp">
                      <LazyLoadImage
                        src={
                          "https://staticcdn.redcliffelabs.com/media/gallary-images/None/3f2cc36c-46ba-4f3b-a0be-9e2a4691f317.webp"
                        }
                        alt={
                          "https://staticcdn.redcliffelabs.com/media/gallary-images/None/3f2cc36c-46ba-4f3b-a0be-9e2a4691f317.webp"
                        }
                        delayTime="100"
                        width="100%"
                      />
                    </div>
                    <div className="card__contentlp">
                      <span className="mainHeading">Sample Collection</span>
                      <span className="redHeading">{packDetail.sample}</span>
                    </div>
                  </div>
                ) : null}

                {/**Home collection packDetail.home_collection */}
                {packDetail?.org_type !== "imaging" &&
                  packDetail &&
                  packDetail.home_collection ? (
                  <div className="lpcards">
                    <div className="card__imglp">
                      <LazyLoadImage
                        src={homeCar}
                        alt={homeCar}
                        delayTime="100"
                        width="100%"
                      />
                    </div>
                    <div className="card__contentlp">
                      <span className="mainHeading">Home Collection</span>
                      <span className="redHeading">Available</span>
                    </div>
                  </div>
                ) : null}

                {packDetail?.org_type !== "imaging" &&
                  packDetail &&
                  packDetail.recommended_age ? (
                  <div className="lpcards">
                    <div className="card__imglp">
                      <LazyLoadImage
                        src={
                          "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                        }
                        alt={
                          "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                        }
                        delayTime="100"
                        width="100%"
                      />
                    </div>
                    <div className="card__contentlp">
                      <span className="mainHeading">Age Group</span>
                      <span className="redHeading">
                        {packDetail.recommended_age} years
                      </span>
                    </div>
                  </div>
                ) : null}

                {packDetail?.org_type == "imaging" ? (
                  <div className="lpcards">
                    <div className="card__imglp">
                      <img
                        src={
                          "https://staticcdn.redcliffelabs.com/media/gallary-file/None/d4af6e2d-7e56-49ef-8b30-3dca6bfc175c.svg"
                        }
                        width="100%"
                        alt={
                          "https://staticcdn.redcliffelabs.com/media/gallary-file/None/d4af6e2d-7e56-49ef-8b30-3dca6bfc175c.svg"
                        }
                      />
                    </div>
                    <div className="card__contentlp">
                      <span className="mainHeading"> Lady technician</span>
                      <span className="redHeading">Available</span>
                    </div>
                  </div>
                ) : null}
                {packDetail?.org_type == "imaging" ? (
                  <div className="lpcards">
                    <div className="card__imglp">
                      <img
                        src={
                          "https://staticcdn.redcliffelabs.com/media/gallary-file/None/7bfe3e30-2046-440b-bf04-e17f0aa3c87e.svg"
                        }
                        width="100%"
                        alt={
                          "https://staticcdn.redcliffelabs.com/media/gallary-file/None/7bfe3e30-2046-440b-bf04-e17f0aa3c87e.svg"
                        }
                      />
                    </div>
                    <div className="card__contentlp">
                      <span className="mainHeading"> Parking facility</span>
                      <span className="redHeading">Available</span>
                    </div>
                  </div>
                ) : null}
                {packDetail?.org_type == "imaging" ? (
                  <div className="lpcards">
                    <div className="card__imglp">
                      <img
                        src={
                          "https://staticcdn.redcliffelabs.com/media/gallary-file/None/afa165a6-47e5-424b-97ac-7cf9359b3b87.svg"
                        }
                        width="100%"
                        alt={
                          "https://staticcdn.redcliffelabs.com/media/gallary-file/None/afa165a6-47e5-424b-97ac-7cf9359b3b87.svg"
                        }
                      />
                    </div>
                    <div className="card__contentlp">
                      <span className="mainHeading"> 100 %</span>
                      <span className="redHeading">Covid Safe</span>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        {faqData?.length > 0 && (
          <div className="LpTestDescMob">{faqData[0].answer}</div>
        )}
        <div className="gautamGam">
          <img src={lpImage ? samantha : gambhir} width="100%" />
        </div>
        {/*** wHY CHOOSE US */}

        <div className="WhyChooseUs">
          <div className="whyUscontainer">
            <h3>Why Choose Us?</h3>
            <div className="Four_div_box">
              <div className="For_Image_And_text">
                <div className="WhyChooseUslogo">
                  <LazyLoadImage
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ae34b20a-80ce-4813-b2e8-e1afb4731f53.webp"
                    }
                    alt="Assured Safety"
                    delayTime="100"
                    width="100%"
                  />
                </div>
                <p className="whyChooseUspara"> Assured Safety</p>
              </div>
              <div className="For_Image_And_text">
                <div className="WhyChooseUslogo">
                  <LazyLoadImage
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/6e9c830a-513d-4477-a405-61abc9e94187.webp"
                    }
                    alt="Certified Labs"
                    delayTime="100"
                    width="100%"
                  />
                </div>
                <p className="whyChooseUspara"> Certified Labs</p>
              </div>
              {packDetail?.org_type !== "imaging" && (
                <div className="For_Image_And_text">
                  <div className="WhyChooseUslogo">
                    <LazyLoadImage
                      src={
                        "https://staticcdn.redcliffelabs.com/media/gallary-images/None/d790df8a-dc9c-4355-bd73-4b4d81821382.webp"
                      }
                      alt="Free Sample Pick-Up"
                      delayTime="100"
                      width="100%"
                    />
                  </div>
                  <p className="whyChooseUspara">
                    {packDetail.offer_price >
                      packDetail.min_booking_amount_for_phlebo
                      ? "Free"
                      : null}{" "}
                    Sample Pick-Up{" "}
                  </p>
                </div>
              )}
              <div className="For_Image_And_text">
                <div className="WhyChooseUslogo">
                  <LazyLoadImage
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/02f40e8a-d0ff-41de-bdea-4f69968c0ae0.webp"
                    }
                    alt="Accurate Reports"
                    delayTime="100"
                    width="100%"
                  />
                </div>
                <p className="whyChooseUspara"> Accurate Reports</p>
              </div>
            </div>
            <div className="forBackgroundcolor">{/* Blank */}</div>
          </div>
        </div>
        {/**SAFETY STEPS */}
        <div className="safetyDiv">
          <h3>5 Steps to Safety</h3>
          <p>
            <span>10+ Lacs</span> Total orders delivered
          </p>
          <div className="safetySteps">
            {stepsData.map((values, index) => (
              <div className="safety__card" key={values.id}>
                <div className="safety_cardIMG">
                  <LazyLoadImage
                    src={values.img}
                    alt="image"
                    delayTime="100"
                    width="100%"
                  />
                </div>
                <div className="steps">
                  <span>{values.id}</span>
                </div>
                <div className="safetyStep">
                  <span>{values.desc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* <Steps /> */}

        {/***APPOINTMENT DIV */}
        {/* <div className="appointMentLpDiv">
          <Apointment
            img={
              "https://staticcdn.redcliffelabs.com/media/gallary-images/None/76164f75-aed7-4ac1-a401-c23961ee59e7.webp"
            }
            width="100%"
            parentPath={"lpPage"}
          />

          <div className="mobileApointment">
            <h5>Make Appointment</h5>
            <p>Start Your Journey With Healthy India Ki Trusted Lab.</p>
          </div>
          <LpForm
            butname={"Book Your Test"}
            position={"bottom"}
            isLp={true}
            title={"Book Your Test"}
            isLp={true}
            lpNumber={footerTel}
          />
        </div> */}

        <Featured />
        {/*** TESTIMONIAL */}
        <Content title="Testimonials" Ispackage={false} isTestimonial={true} />
        {/**FAQS */}
        <div className="FAQforLp ">
          {faqData?.length > 0 && (
            <h1 className="h1style"> Frequently Asked Questions</h1>
          )}
          {faqData?.length > 0 &&
            faqData?.map((value, index) => (
              <div key={value.id}>
                <FaqAccorComponent value={value} />
              </div>
            ))}
        </div>
        {/***FOOTER */}
        {/**BASIC FOOTER */}

        <div className="footerLp">
          <div className="footerContainer">
            <div className="footerFirstRow">
              <div className="logoIMg">
                <img
                  className="lpimg"
                  width="100%"
                  src={
                    packDetail?.org_type !== "imaging"
                      ? "https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                      : "https://staticcdn.redcliffelabs.com/media/gallary-file/None/39350684-4581-4a0d-b297-52fb3452aa93.webp"
                  }
                  alt={logoWhite}
                ></img>
              </div>
              <div className="footerDesc">
                <p>
                  Redcliffe Labs is an accredited advanced diagnostic laboratory
                  that aims at providing top-notch consistent and accurate
                  laboratory services with modern technology and equipment all
                  inclusive of logistics management.
                </p>
              </div>
            </div>
            <div className="footerSecondRow">
              <div className="footerLogo">
                <span>Contact Us</span>
                <div className="emailLogo">
                  <span>
                    <FiMail />
                  </span>
                  care@redcliffelabs.com
                </div>
                <a href={`tel:+91${footerTel}`}>
                  <div className="phoneLogo">
                    <span>
                      <FiPhone />
                    </span>
                    {footerTel}
                  </div>
                </a>
              </div>
            </div>
            <div className="borderDiv"></div>
            <div className="footerThirdRow">
              <div className="footerMsg">
                <p>
                  Redcliffe Labs <br /> © 2022. All rights reserved.
                </p>
                <p>
                  Disclaimer: As per "Pre-Natal Diagnostic Techniques
                  (Regulation and prevention of Misuse) Act, 1994", our labs
                  strictly does not determine the sex of the fetus.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/***FIXED FOOTER */}
        <div className="Lpfooter">
          <div className="lpfooter__content">
            <form id="LpBottomForm" onSubmit={handelSubmit}>
              <div className="nameInput ">
                Name
                <input
                  type="text"
                  onChange={handelUserName}
                  className={nameError ? "colorRed" : ""}
                  placeholder={nameError ? nameError : "Enter Name"}
                  value={nameError ? () => setUserName("") : userName}
                ></input>
              </div>
              <div className="phoneInput">
                Phone Number
                <input
                  type="text"
                  className={phoneError ? "colorRed" : ""}
                  placeholder={phoneError ? phoneError : "Enter Phone Number"}
                  value={phoneError ? () => setUserName("") : userNumber}
                  onChange={handelPhoneChange}
                  required
                ></input>
              </div>

              {successBtn ? (
                <div className="submitButton__lpfooter">
                  <button
                    disabled="disabled"
                    className="btnSuccess"
                    type="submit"
                  >
                    Success
                  </button>
                </div>
              ) : (
                <div className="submitButton__lpfooter">
                  <button
                    id={isMobile ? "MobileLpbottom" : "Lpbottom"}
                    disabled={nameError || disable ? "disabled" : null}
                    className={nameError || disable ? "disabled" : null}
                    type="submit"
                  >
                    Book Now
                  </button>
                </div>
              )}
            </form>
          </div>
          <div className="mobileFooterDiv">
            <button>
              <a href={`tel:+91${footerTel}`}> Consult Now </a>
            </button>

            <button id="MobFotterButton" onClick={scrollTop}>
              Book Now
            </button>
          </div>
          {/* <button id="MobFotterButton" onClick={scrollTop}>
            Book Now
          </button> */}
        </div>

        {/* Notification popup */}
        <Modal
          classNames={{
            overlay: "customOverlay",
            modal: "notificationPopup_modal",
          }}
          open={open1}
          onClose={onCloseModal1}
          center
        >
          <Popup setOpen={setOpen1} />
        </Modal>

        <ScrolltoTop />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  package: state?.lpPackage?.lpPackageData,
  loading: state?.lpPackage?.loadinglp,
  success: state?.lpPackage?.success,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getLppackageDetails: (lpslug) => {
      dispatch(Actions.getLppackageDetails(lpslug));
    },
    getLppackageAliasDetails: (lpslug) => {
      dispatch(Actions.getLppackageAliasDetails(lpslug));
    },
    getCall: (body) => {
      dispatch(Actions.getCall(body));
    },
  };
};
export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(Lp)),
};
